<template>
    <div class="compliance-badge"
         :class="testClass">
        <b-badge :variant="badgeVariant" class="m-1">
            {{ statusLabel }}
        </b-badge>
        <b-badge variant="success" class="m-1"
                 v-if="complianceHasExemption">
            Exempt
        </b-badge>
    </div>
</template>

<script>
export default {
    name: 'ComplianceBadge',
    props: {
        compliance: Object
    },
    computed: {
        complianceStatus() {
            return this.compliance?.status
        },
        complianceEffective() {
            return this.compliance?.effective
        },
        complianceHasExemption() {
            return this.compliance?.has_exemption
        },
        statusLabel () {
            const status = this.complianceStatus
            if (status === 'NA') {
                return 'N/A'
            } else if (status === 'NONCOVERED') {
                return 'Non-Covered'
            } else if (status === 'COMPLIANT') {
                return 'Compliant'
            } else if (status === 'NONCOMPLIANT') {
                return 'Noncompliant'
            } else {
                return '-'
            }
        },
        badgeVariant () {
            const status = this.complianceStatus
            if (status === 'NA') {
                return 'warning'
            } else if (status === 'NONCOVERED') {
                return 'success'
            } else if (status === 'COMPLIANT') {
                return 'success'
            } else if (status === 'NONCOMPLIANT') {
                return 'danger'
            } else {
                return 'default'
            }
        },
        testClass () {
            return `t-${this.complianceEffective}`
        }
    }
}
</script>

<style lang="scss">
.compliance-badge {
    display: inline-block;
}
</style>
